import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  Text,
  DrawerHeader,
  DrawerOverlay,
  DrawerProps,
  Flex,
  Table,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Thead,
  Box,
  Button,
  Image,
  Input,
  HStack,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  useToast,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import { useCalculatePrice, useHistory, useSelectedGeometries } from "../hook";
import { thuaDatChiTiet as mockThua } from "../_mocks_";
import {
  IChiTietDinhGia,
  IDropdownItem,
  IDinhGia,
  IThuaDatIdentity,
  IChiTietThuaDat,
  IDisplayGeo,
} from "../_types_";
import { savePrice } from "../apis/giadat.api";
import Dropdown from "./Dropdown";
import LichSuGiaDat from "./LichSuGiaDat";
import { getToast, numberFormat } from "../utils";
import InputCustom from "./common/InputCustom";
import WaitingModal from "../containers/WaitingModal";
import { useGlobal } from "../contexts/Globals";

interface IProps extends Omit<DrawerProps, "children">, IThuaDatIdentity {
  setSelectedGeometries: (data: IDisplayGeo[]) => void;
}
export default function ThongTinGiaDat({
  isOpen,
  onClose,
  maHuyen,
  maXa,
  soTo,
  soThua,
  setSelectedGeometries: parentSelectedGeometries,
}: IProps) {
  const { isHasEditRole } = useGlobal();
  const [tabIndex, setTabIndex] = useState(0);
  const [isNotFound, setIsNotFound] = useState(false);
  const [thuaDatChiTiet, setThuaDatChiTiet] =
    useState<IChiTietThuaDat>(mockThua);
  const { thuaDat } = thuaDatChiTiet;
  const btnRef = React.useRef(null);
  const [mdsd, setMdsd] = React.useState<IDropdownItem[]>([]);
  const [dsDinhGia, setDsDinhGia] = useState<IDropdownItem[]>([]);
  const [dinhGia, setDinhGia] = useState<IDinhGia>();
  const [chiTiet, setChiTiet] = React.useState<IChiTietDinhGia[]>([]);
  const [indexDinhGia, setIndexDinhGia] = useState<number>(0);
  //indexKhuVuc
  const [indexKhuVuc, setIndexKhuVuc] = useState<number>(0);

  const [dsKhuVuc] = useState<IDropdownItem[]>([
    {
      lable: `Khu vực 1`,
      value: 1,
    },
    {
      lable: `Khu vực 2`,
      value: 2,
    },
  ]);

  const [thuaDatIdentity, setThuaDatIdentity] = useState<IThuaDatIdentity>({
    maHuyen: maHuyen,
    maXa: maXa,
    soTo: soTo,
    soThua: soThua,
  });
  const [history, setHistory] = useHistory(thuaDatIdentity);
  const { giaDat, isLoading } = useCalculatePrice(thuaDatIdentity);
  const [geometries, setSelectedGeometries] =
    useSelectedGeometries(thuaDatIdentity);
  const toast = useToast();

  function geoFromDinhGia() {
    const dinhGiaSelect = thuaDatChiTiet.dinhGias[indexDinhGia];
    const geos = dinhGiaSelect.geometries.map((q) => {
      const dgeo: IDisplayGeo = {
        color: q.color,
        geo: q.geometry,
      };
      return dgeo;
    });
    //route geo
    const routeGeo = dinhGiaSelect.routeGeometries;
    if (routeGeo && routeGeo.length > 0) {
      const dRGeo = routeGeo.map((m) => {
        const dgeo: IDisplayGeo = {
          color: "blue",
          geo: m,
        };
        return dgeo;
      });
      geos.push(...dRGeo);
    }
    return geos;
  }

  const initData = useCallback(() => {
    const mdResult = thuaDatChiTiet.thuaDat.mucDichSuDungs.map((p) => {
      const item: IDropdownItem = {
        value: p.kyHieu,
        lable: p.kyHieu,
      };
      return item;
    });
    setMdsd(mdResult);

    const rs = thuaDatChiTiet.dinhGias.map((p, index) => {
      const item: IDropdownItem = {
        lable: `${p.tenDuong} ${
          p.tenHem ?? p.chieuDaiHem ? p.chieuDaiHem : ""
        }`,
        value: index,
      };
      return item;
    });
    setDsDinhGia(rs);
    setIndexDinhGia(0);
  }, [thuaDatChiTiet]);

  useEffect(() => {
    initData();
  }, [initData]);

  useEffect(() => {
    if (isOpen) {
      const geos = geoFromDinhGia();

      setSelectedGeometries(geos);
    } else {
      //setSelectedGeometries([]);
    }
  }, [isOpen]);

  useEffect(() => {
    setThuaDatIdentity({
      maHuyen: maHuyen,
      maXa: maXa,
      soTo: soTo,
      soThua: soThua,
    });
    if (isOpen) {
      const geos = geoFromDinhGia();
      setSelectedGeometries(geos);
    }
  }, [maHuyen, maXa, soTo, soThua]);

  useEffect(() => {
    if (giaDat) {
      setThuaDatChiTiet(giaDat);
      setIsNotFound(false);
    } else setIsNotFound(true);
  }, [giaDat]);

  useEffect(() => {
    const dinhGiaSelect = thuaDatChiTiet.dinhGias[indexDinhGia];
    const geos = geoFromDinhGia();
    setSelectedGeometries(geos);
    setDinhGia(dinhGiaSelect);
    setChiTiet(dinhGiaSelect.chiTiets);
  }, [indexDinhGia, thuaDatChiTiet]);

  useEffect(() => {
    parentSelectedGeometries(geometries);
  }, [geometries]);

  const handleChangeValue = (
    index: number,
    val: string | number,
    type: "MDSD" | "DIEN_TICH" | "GIA"
  ) => {
    const newChiTiet = [...chiTiet];
    switch (type) {
      case "MDSD": {
        newChiTiet[index].mdsd = val.toString();
        break;
      }
      case "DIEN_TICH": {
        newChiTiet[index].dienTich = Number.parseFloat(val.toString());
        break;
      }
      case "GIA": {
        newChiTiet[index].gia = Number.parseFloat(val.toString());
        tinhGiaMoi(newChiTiet);
        break;
      }
      default:
        break;
    }
    setChiTiet(newChiTiet);
  };

  const handleChangeGiaValue = (val: number) => {
    if (!dinhGia) return;
    setDinhGia({ ...dinhGia, giaThiTruong: val });
  };

  const tinhGiaMoi = (chiTiet: IChiTietDinhGia[]) => {
    if (!dinhGia) return;
    let tongChiTiet = 0;
    chiTiet.forEach((p) => (tongChiTiet += p.gia || 0));
    let tongGia = tongChiTiet * dinhGia.heSoTiepGiapDuong;
    setDinhGia({ ...dinhGia, tongGia });
  };

  const handleSaveClick = async () => {
    if (!dinhGia) return;

    try {
      let dinhGiaSave = null;
      if (!dinhGia.routeGeometries)
        dinhGiaSave = { ...dinhGia, routeGeometries: [] };
      else dinhGiaSave = { ...dinhGia };

      const request = { ...thuaDatIdentity, ...dinhGiaSave, chiTiets: chiTiet };
      await savePrice(maHuyen, maXa, request);
      await setHistory();
      setTabIndex(0);
    } catch (er: any) {
      console.log("handleSaveClick", er);
      toast(getToast(er.ChiTiets[0].toString(), "error", "error"));
    }
  };

  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size={"lg"}
      >
        <DrawerOverlay />
        <DrawerContent w="1000px">
          <DrawerCloseButton />
          <DrawerHeader>
            {`Thông Tin Thửa Đất: ${
              isNotFound
                ? "Thửa đất không tồn tại"
                : `${thuaDat.soTo}/${thuaDat.soThua}`
            }`.toUpperCase()}
          </DrawerHeader>
          <DrawerBody padding="0px">
            <Tabs
              hidden={isNotFound}
              isFitted
              variant="soft-rounded"
              index={tabIndex}
              onChange={(index) => {
                setTabIndex(index);
              }}
            >
              <TabList mb="1em">
                {history && history.dinhGias?.length != 0 && (
                  <Tab key={history.dinhGias[0]?.tongGia}>Lịch sử</Tab>
                )}
                <Tab>Định giá</Tab>
              </TabList>
              <TabPanels>
                {history && history.dinhGias?.length != 0 && (
                  <TabPanel padding={0}>
                    <LichSuGiaDat
                      key={history.dinhGias[0]?.tongGia || ""}
                      thuaDatChiTiet={history}
                    />
                  </TabPanel>
                )}
                <TabPanel padding={0}>
                  <Box w="full" border="2px solid #fff" boxShadow="base">
                    <TableContainer w="full">
                      <Table size="sm" className="tbl-gia-dat">
                        <Tbody>
                          <Tr>
                            <Th w="30%">Định giá:</Th>
                            <Td>
                              <Dropdown
                                data={dsDinhGia}
                                selectedVal={indexDinhGia}
                                onChange={(val) =>
                                  setIndexDinhGia(val as number)
                                }
                              />
                            </Td>
                          </Tr>
                          {/* {
                            <Tr>
                              <Th w="30%">Khu vực:</Th>
                              <Td>
                                <Dropdown
                                  data={dsKhuVuc}
                                  selectedVal={indexKhuVuc}
                                  onChange={(val) =>
                                    setIndexKhuVuc(val as number)
                                  }
                                />
                              </Td>
                            </Tr>
                          }{" "} */}
                          <Tr>
                            <Th>Thửa liền kề:</Th>
                            <Td>{dinhGia?.thuaLienKe || "--"}</Td>
                          </Tr>
                          <Tr>
                            <Th>Tên đường:</Th>
                            <Td>{dinhGia?.tenDuong || "--"}</Td>
                          </Tr>
                          <Tr>
                            <Th>Tên đoạn đường:</Th>
                            <Td>{dinhGia?.tenDoanDuong || "--"}</Td>
                          </Tr>
                          <Tr>
                            <Th>Tên hẻm:</Th>
                            <Td>{dinhGia?.tenHem || "--"}</Td>
                          </Tr>
                          <Tr>
                            <Th>Tên đường giao:</Th>
                            <Td>{dinhGia?.tenDuongGiao || "--"}</Td>
                          </Tr>
                          <Tr>
                            <Th>Phương pháp định giá:</Th>
                            <Td>{dinhGia?.phuongPhapDinhGia || "--"}</Td>
                          </Tr>
                          <Tr>
                            <Th>Hệ số tiếp giáp:</Th>
                            <Td>{dinhGia?.heSoTiepGiapDuong || "--"}</Td>
                          </Tr>
                          <Tr>
                            <Th>Tổng giá:</Th>
                            <Td>
                              {dinhGia?.tongGia
                                ? numberFormat(dinhGia?.tongGia)
                                : ""}{" "}
                            </Td>
                          </Tr>
                          <Tr>
                            <Th>Đơn vị tính</Th>
                            <Td> 1.000 VNĐ</Td>
                          </Tr>
                          <Tr>
                            <Th>Giá thị trường:</Th>
                            <Td>
                              <Input
                                value={
                                  dinhGia?.giaThiTruong === 0
                                    ? ""
                                    : dinhGia?.giaThiTruong
                                }
                                type="number"
                                onChange={(e) =>
                                  handleChangeGiaValue(e.target.valueAsNumber)
                                }
                              />
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <Flex
                    w="full"
                    flexDirection="column"
                    mt="20px"
                    border="1px solid #fff"
                    padding="5px"
                    borderRadius="5px"
                    boxShadow="base"
                  >
                    <TableContainer w="full" overflowX="hidden">
                      <Table size="sm" className="tbl-gia-dat">
                        <Thead>
                          <Tr>
                            <Th>Vị trí</Th>
                            <Th>DT Khu Vực</Th>
                            <Th>MĐSD</Th>
                            <Th>Diện tích (m&sup2;)</Th>
                            <Th textAlign="center">
                              Đơn giá
                              <br />
                              (1.000vnđ)
                            </Th>
                            <Th textAlign="center">
                              Giá
                              <br />
                              (1.000vnđ)
                            </Th>
                            <Th></Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {chiTiet.map((p, index) => {
                            return (
                              <Tr key={String(index)}>
                                <Td>{p.tenVung}</Td>
                                <Td>{p.dienTichVung}</Td>
                                <Td>
                                  <Dropdown
                                    data={mdsd}
                                    selectedVal={p.mdsd}
                                    onChange={(v) =>
                                      handleChangeValue(index, v, "MDSD")
                                    }
                                  />
                                </Td>
                                <Td
                                  w="10%"
                                  paddingLeft="6px"
                                  paddingRight="2px"
                                >
                                  <InputCustom
                                    value={p.dienTich}
                                    onChange={(v) =>
                                      handleChangeValue(index, v, "DIEN_TICH")
                                    }
                                  />
                                </Td>
                                <Td>
                                  {p?.donGiaKV1
                                    ? numberFormat(p.donGiaKV1)
                                    : "--"}
                                </Td>
                                <Td
                                  w="20%"
                                  paddingLeft="6px"
                                  paddingRight="2px"
                                >
                                  <InputCustom
                                    value={p.gia}
                                    onChange={(v) =>
                                      handleChangeValue(index, v, "GIA")
                                    }
                                  />
                                </Td>
                                <Td paddingLeft="0px">
                                  <HStack>
                                    <Image
                                      cursor="pointer"
                                      w="18px"
                                      h="18px"
                                      src="./imgs/add.png"
                                      alt="thêm"
                                      onClick={() => {
                                        const newChitiet = [...chiTiet];
                                        newChitiet.splice(index, 0, p);
                                        setChiTiet(newChitiet);
                                      }}
                                    />

                                    {chiTiet.filter(
                                      (i) => i.tenVung === p.tenVung
                                    ).length > 1 && (
                                      <Image
                                        cursor="pointer"
                                        w="20px"
                                        h="20px"
                                        src="./imgs/close.png"
                                        alt="Xoá"
                                        onClick={() => {
                                          const newChitiet = [...chiTiet];
                                          newChitiet.splice(index, 1);
                                          setChiTiet(newChitiet);
                                        }}
                                      />
                                    )}
                                  </HStack>
                                </Td>
                              </Tr>
                            );
                          })}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Flex>
                  {isHasEditRole && (
                    <Button w="full" mt="10px" onClick={handleSaveClick}>
                      <Text>Lưu định giá</Text>
                    </Button>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </DrawerBody>

          {isLoading && <WaitingModal />}
        </DrawerContent>
      </Drawer>
    </>
  );
}
